import { ActionButton, Link } from '@fluentui/react';
import DefaultTextView from '../../../common/views/DefaultTextView';
import { Utils } from '../../../common/views/Utils';
import { SocialAccountModel, SocialAccountType } from '../../models/SocialAccountModel';

export type AccountItemProps = {
    account: SocialAccountModel;
    onEdit: (account: SocialAccountModel) => void;
    onDelete: (account: SocialAccountModel) => void;
}

export default function AccountItemView({ account, onEdit, onDelete }: AccountItemProps) {
    const width4 = Utils.getColumnWidth(4);
    const width6 = Utils.getColumnWidth(6);
    const width8 = Utils.getColumnWidth(8);
    const width12 = Utils.getColumnWidth(12);

    const row1 = () => {
        return <div className="ms-Grid-row">
            <div className={width8 + " left"}>{account.name}</div>
            <div className={width4 + " right"}>{account.isPrimary && <>
                <DefaultTextView text="default" />
            </>}</div>
        </div>
    }

    const row2 = () => {
        return <div className="ms-Grid-row pt-10">
            <div className={width12 + " left"}>{SocialAccountType[account.type]}</div>
        </div>
    }

    const row3 = () => {
        return <div className="ms-Grid-row pt-10">
            <div className={width12 + " left"}>
                <Link href={account.url} target="_blank">{account.url}</Link>
            </div>
        </div>
    }

    const actionRow = () => {
        return <div className="ms-Grid-row default-toolbar">
            <div className={width6 + " left"}>
                <ActionButton
                    iconProps={{ iconName: "Edit" }}
                    onClick={() => onEdit(account)}
                >Edit</ActionButton>
            </div>

            <div className={width6 + " right"}>
                <ActionButton
                    iconProps={{ iconName: "Delete" }}
                    onClick={() => onDelete(account)}
                >Delete</ActionButton>
            </div>
        </div>;
    }

    return <div className="ph-15">
        <div className="ms-Grid pt-10 default-border">
            <div className="pt-5 pb-15 ph-5">
                {row1()}
                {row2()}
                {!Utils.isNullOrEmpty(account.url) && row3()}
            </div>

            {actionRow()}
        </div>
    </div>;
}